import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class City {
  public static async load() {
    useDispatch(Action.Company.City.setStatus("loading"));
    try {
      const response = await new Model.Company().city();
      useDispatch(Action.Company.City.setList(response.data));
      useDispatch(Action.Company.City.setStatus("loaded"));
      return response.data;
    } catch (Exception) {
      throw Exception;
    }
  }
}
